import { getAllDepartments } from './api';

const initialize = new Promise((resolve, reject) => {
    let count = 0;
    let promises = [
        Promise.resolve(getAllDepartments())
    ];
    let resolveFn = () => { count += 1; if (count === promises.length) resolve('OK'); };
    promises.forEach((item) => item.then(() => resolveFn()));
});

export default initialize;


// WEBPACK FOOTER //
// ./src/common/init.js